import { Fragment, useEffect } from 'react';
import { ProductFruits } from 'react-product-fruits';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentOperation } from 'src/module/operation/operation.slice';
import { AuthenticationActions } from '../../../corelogic/usecases/authentication/authenticationActions';
import {
  selectCgu,
  selectIsAuthenticating,
  selectUser,
} from '../../../corelogic/usecases/authentication/authenticationSelector';
import { NavigationActions } from '../../../corelogic/usecases/navigation/navigationActions';
import { initOperations, initSelectedOperation } from '../../../corelogic/usecases/operation/operationActions';
import CguModal from './Components/global/PopUps/cgu-popup';
import Routes from './Routes';

type TAppProps = {
  history: any;
};

const App = ({ history }: TAppProps) => {
  const dispatch = useDispatch();

  const cgu = useSelector(selectCgu);
  const isAuthenticating = useSelector(selectIsAuthenticating);
  const user = useSelector(selectUser);
  const operation = useSelector(selectCurrentOperation);
  useEffect(() => {
    if (!process.env.REACT_APP_UMAMI_TOKEN) return;
    const umami = document.createElement('script');
    umami.setAttribute('defer', 'true');
    umami.setAttribute('src', 'https://cloud.umami.is/script.js');
    umami.setAttribute('data-website-id', process.env.REACT_APP_UMAMI_TOKEN);
    document.head.appendChild(umami);
  }, []);

  useEffect(() => {
    dispatch(AuthenticationActions.getUser());
    dispatch(NavigationActions.getAppmap());
  }, [dispatch]);

  useEffect(() => {
    const androidChromeLink = document.querySelector("link[href*='android-chrome-192x192.png']") as HTMLLinkElement;
    const faviconLink = document.querySelector("link[href*='favicon.ico']") as HTMLLinkElement;
    const faviconLink16 = document.querySelector("link[href*='favicon-16x16.png']") as HTMLLinkElement;
    const faviconLink32 = document.querySelector("link[href*='favicon-32x32.png']") as HTMLLinkElement;

    if (operation && operation.legalRegion === 'BRUXELLES') {
      document.title = 'BEST';
      if (androidChromeLink) androidChromeLink.href = androidChromeLink.href.replace('.png', '-simply.png');
      if (faviconLink) faviconLink.href = faviconLink.href.replace('.ico', '-simply.ico');
      if (faviconLink16) faviconLink16.href = faviconLink16.href.replace('.png', '-simply.png');
      if (faviconLink32) faviconLink32.href = faviconLink32.href.replace('.png', '-simply.png');
    } else if (operation && operation.legalRegion === 'FRANCE') {
      document.title = 'Enoconso';
    }
  }, [operation]);

  const handleLogOut = () => {
    dispatch(AuthenticationActions.logOut(history));
    dispatch(initSelectedOperation());
    dispatch(initOperations());
  };

  const handleAcceptCgu = (cguId: number) => {
    dispatch(AuthenticationActions.acceptCgu(cguId, history));
  };

  const productFruitsUser = {
    username:
      `${user._firstName || ''} ${user._lastName && user._lastName !== 'TBD' && user._lastName !== 'UNSET' ? user._lastName : ''}`.trim(),
    email: user?._email || '',
    firstname: user?._firstName || '',
    lastname: user?._lastName || '',
    role: user?._role || '',
    props: {
      dso: operation?.dso || 'NO_DSO_FOUND',
      legalRegion: operation?.legalRegion || 'NO_COUNTRY_FOUND',
    },
  };
  return (
    <Fragment>
      {productFruitsUser.username && operation?.dso && operation.dso !== 'SIBELGA' && (
        <ProductFruits
          workspaceCode={process.env.REACT_APP_PRODUCT_FRUIT_WORKSPACE_CODE || 'add-product-fruit-code-in-.env'}
          language="fr"
          user={productFruitsUser}
        />
      )}
      <CguModal isOpen={(cgu as any).open} onAccept={handleAcceptCgu} />
      {!isAuthenticating && <Routes childProps={{ handleLogout: handleLogOut }} />}
    </Fragment>
  );
};

export default App;
